"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleChatCommentReactionArgsValidator = exports.toggleChatCommentReactionArgsSchema = exports.chatReactions = exports.updateChatCommentArgsValidator = exports.updateChatCommentArgsSchema = exports.deleteChatCommentArgsValidator = exports.deleteChatCommentArgsSchema = exports.createChatCommentArgsValidator = exports.createChatCommentArgsSchema = exports.MAX_CHAT_COMMENT_BODY_LENGTH = exports.createChatCommentFromArgs = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../../../common");
var channel_1 = require("../channel");
var arrayOps_1 = require("../../../utils/arrayOps");
function createChatCommentFromArgs(user, args, replyToParticipants, threadId) {
    return {
        authorId: user.id,
        details: __assign(__assign({}, (user.name && !args.incognito) && {
            authorName: user.name
        }), { participants: (0, arrayOps_1.arraySavePush)(replyToParticipants, user.id), body: args.body, reactions: {}, counters: {
                directReplies: 0
            } }),
        // sort
        createdOn: (new Date()).getTime(),
        // filter
        replyTo: args.replyTo,
        threads: [threadId]
    };
}
exports.createChatCommentFromArgs = createChatCommentFromArgs;
// --------------------------
// constants
// --------------------------
exports.MAX_CHAT_COMMENT_BODY_LENGTH = 2000;
// --------------------------
// create
// --------------------------
exports.createChatCommentArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("createChatComment").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    chatCommentId: common_1.idSchema.required(),
    body: suretype_1.v.string().maxLength(exports.MAX_CHAT_COMMENT_BODY_LENGTH).required(),
    replyTo: suretype_1.v.anyOf([suretype_1.v.null(), common_1.idSchema]).required(),
    incognito: suretype_1.v.boolean().required(),
});
exports.createChatCommentArgsValidator = (0, suretype_1.compile)(exports.createChatCommentArgsSchema);
// --------------------------
// delete
// --------------------------
exports.deleteChatCommentArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("deleteChatComment").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    chatCommentId: common_1.idSchema.required()
});
exports.deleteChatCommentArgsValidator = (0, suretype_1.compile)(exports.deleteChatCommentArgsSchema);
// --------------------------
// update
// --------------------------
exports.updateChatCommentArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("updateChatComment").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    chatCommentId: common_1.idSchema.required(),
    body: suretype_1.v.string().maxLength(exports.MAX_CHAT_COMMENT_BODY_LENGTH).required(),
});
exports.updateChatCommentArgsValidator = (0, suretype_1.compile)(exports.updateChatCommentArgsSchema);
// --------------------------
// toggle reaction
// --------------------------
// NOTE we do not offer thumbs down symbol because
// instead of giving a thumbs down, one should give a reason
// why the corresponding post is bad and then thumbs up this comment
exports.chatReactions = ["👍", "🔥", "🙏", "❤️", "😂", "😮", "😔", "😠"];
var chatReactionSchema = (_a = suretype_1.v.string()).enum.apply(_a, exports.chatReactions);
exports.toggleChatCommentReactionArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("toggleChatCommentReaction").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    chatCommentId: common_1.idSchema.required(),
    reaction: chatReactionSchema.required(),
    value: suretype_1.v.boolean().required()
});
exports.toggleChatCommentReactionArgsValidator = (0, suretype_1.compile)(exports.toggleChatCommentReactionArgsSchema);
